import { useModuleBEM } from "@b2bportal/core-themes";
import { HomepageBanner, type HomepageBannerContent } from "../HomepageBanner";
import styles from "./BannerSection.module.scss";
import { Experiments } from "@/modules/experiments/src/hooks/experimentsList";
import { useExperiment } from "@/modules/experiments/src/hooks/useExperiment";
import { BonusEarnBanner, useBonusEarnBanner } from "@/modules/wallet";

export const useHomepageBanners = () => {
  const { getExperimentJsonPayload } = useExperiment();
  const bannerContent = getExperimentJsonPayload<HomepageBannerContent>(
    Experiments.HOMEPAGE_BANNER.name
  );
  const {
    context: { resource: bonusEarnResource },
  } = useBonusEarnBanner();

  return {
    bannerContent,
    hasBanner: !!bannerContent || !!bonusEarnResource,
  };
};

export const BannerSection = () => {
  const [block, cn] = useModuleBEM(styles, "BannerSection");

  const { bannerContent } = useHomepageBanners();

  return (
    <div className={block}>
      <HomepageBanner bannerContent={bannerContent} />
      <BonusEarnBanner />
    </div>
  );
};
